import {MessageViewModel} from './MessageViewModel';

export type SenderType = 'client' | 'server' | 'divider';

export class MessageGroupViewModel {
    constructor(public id: number, public messages: MessageViewModel[], public sender: SenderType, public botAvatarImageUrl?: string) {
    }
}
